import { useNavigate } from 'react-router-dom';

import {
  PageHeader,
  Pagination,
  Table,
  Typography,
} from '../../../../designComponents';
import { getTableData } from './invoicesTableData';
import { InvoicesStyled } from './style';

const Invoices = () => {
  const navigate = useNavigate();

  return (
    <InvoicesStyled>
      <PageHeader
        pageTitle={
          <Typography strong variant="title">
            Invoice List
          </Typography>
        }
        search=""
        handleOnSearchTextChange={() => {}}
      />
      <div className="table-container">
        <Table tableData={getTableData(navigate)} />
      </div>
      <Pagination
        activePage={1}
        handlePagination={() => {}}
        limit={10}
        totalCount={136}
      />
    </InvoicesStyled>
  );
};

export default Invoices;
